// 全局文案配置
const NOTICE_TEXT = {
  // 未缴纳会费提示（模板中展示）
  expireTip: "温馨提示：未缴纳会费，请与协会联系。联系电话：0851-86587369。",
  // 未缴纳会费弹窗提示
  expireDialog: "未缴纳会费，请与协会联系。联系电话：0851-86587369。",
  // 会员过期弹窗提示
  memberExpiredDialog: "会员过期，请与协会联系。联系电话：0851-86587369。",
};

export default NOTICE_TEXT;
